import uuid from 'node-uuid';
import lodash from 'lodash';

import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { toMutation, toQuery, nodeWithArgs } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { binderInstitutionIdSelector } from 'common/selectors';
import { studyNodeWrapper } from 'common/util/studyQueryHelper';
export const LOAD_STUDY_TASKS = 'LOAD_STUDY_TASKS';
export const CREATE_STUDY_TASK = 'CREATE_STUDY_TASK';
export const REMOVE_STUDY_TASK = 'REMOVE_STUDY_TASK';
export const IMPORT_STUDY_TEMPLATE = 'IMPORT_STUDY_TEMPLATE';
export const SAVE_STUDY_TASK = 'SAVE_STUDY_TASK';

export function loadStudyTasks(binderId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const query = nodeWithArgs(
            'studyTasks',
            {
                binderId,
                institutionId,
            },
            ['id', 'taskName', 'taskIndex']
        );

        return queryGraphQL(toQuery(query)).then((results) => {
            const { studyTasks } = results.data;
            dispatch(loadStudyTasksAction(studyTasks));
        });
    };
}

export function loadStudyTasksAction(studyTasks) {
    return {
        type: LOAD_STUDY_TASKS,
        payload: studyTasks,
    };
}

export function createStudyTask(binderId, taskName) {
    const id = uuid.v4();

    return (dispatch, getState) => {
        const state = getState();
        const { study: { id: studyId } = {}} = state;
        const institutionId = binderInstitutionIdSelector(state);
        const tasks = lodash.get(state, 'doaStudyTasks', []);
        let taskIndex = 1;
        if (tasks.length !== 0) {
            const taskIndexes = tasks.map((task) => task.taskIndex);
            const largestCurrentTaskIndex = Math.max(...taskIndexes);
            taskIndex = largestCurrentTaskIndex + 1;
        }

        const query = studyNodeWrapper(
            studyId,
            'createTask',
            nodeWithArgs(
                'createStudyTask',
                {
                    id,
                    binderId,
                    institutionId,
                    taskName,
                    taskIndex,
                },
                ['id', 'taskName', 'taskIndex']
            ));
        
        return mutateGraphQL(toMutation(query)).then((results) => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add task to study'));
            } else {
                dispatch({
                    type: CREATE_STUDY_TASK,
                    payload: results.data[query.name],
                });
            }
        });
    };
}

export function saveStudyTask(newListTask, binderId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const query = nodeWithArgs(
            'saveStudyTasks',
            {
                tasks: newListTask,
                binderId,
                institutionId,
            },
            ['id', 'taskName', 'taskIndex']
        );
        return mutateGraphQL(toMutation(query)).then((results) => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add task to study'));
            } else {
                dispatch({
                    type: SAVE_STUDY_TASK,
                    payload: {
                        doaStudyTasks: results.data.saveStudyTasks,
                    },
                });
            }
        });
    };
}

export function removeStudyTask(taskId, binderId, tasksToBeUpdated) {
    return (dispatch, getState) => {
        const state = getState();
        const { study: { id: studyId } = {}} = state;
        const institutionId = binderInstitutionIdSelector(state);
        const mutation = studyNodeWrapper(
            studyId,
            'removeTask',
            nodeWithArgs(
                'removeStudyTask',
                {
                    id: taskId,
                    binderId,
                    institutionId,
                    input: tasksToBeUpdated,
                },
                ['taskName', 'taskIndex', 'id']
            ));

        return mutateGraphQL(toMutation(mutation)).then((results) => {
            if (results.errors) {
                dispatch(
                    addApplicationMessage(
                        'error',
                        'An error occurred when deleting the study task.'
                    )
                );
            } else {
                dispatch({
                    type: REMOVE_STUDY_TASK,
                    payload: {
                        doaStudyTasks: results.data[mutation.name],
                    },
                });
            }
        });
    };
}

export function importStudyTemplate(templateName, binderId, institutionId) {
    return (dispatch, getState) => {
        const state = getState();
        const { study: { id: studyId } = {}} = state;
        const mutation = studyNodeWrapper(
            studyId,
            'importTemplate',
            nodeWithArgs(
                'importStudyTemplate',
                {
                    templateName,
                    binderId,
                    institutionId,
                },
                ['id', 'taskName', 'taskIndex']
            ));

        return mutateGraphQL(toMutation(mutation)).then((results) => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to import study key template'));
            } else {
                dispatch({
                    type: IMPORT_STUDY_TEMPLATE,
                    payload: results.data[mutation.name],
                });
            }
        });
    };
}